import React, { useRef, useEffect, useState } from "react";

declare const window: any;

function PropertiesOverlaysContainer({
  setIsSelectedApto,
  isSelectedApto,
  colors,
  theme,
  active,
  frame,
  filter,
  inmueblesUrl,
  originalWidth,
  originalHeight,
  data,
  selectAvailability,
  isSelectedAttribute,
  dragStart,
  setDragStart,
  setIsAnimationAttribute,
  isAnimationAttribute,
}: any) {
  const svgRef = useRef<SVGSVGElement | null>(null);
  const [inmueblesData, setInmueblesData]: any = React.useState([]);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [screenHeight, setScreenHeight] = useState(window.innerHeight);

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${
            window.hybrid
              ? "./"
              : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/"
          }${inmueblesUrl}`
        );
        const data = await response.json();
        setInmueblesData(data.properties_coord_file);
      } catch (error) {
        console.error("Error al cargar los datos:", error);
      }
    };

    fetchData();

    const handleResize = () => {
      setScreenWidth(window.innerWidth);
      setScreenHeight(window.innerHeight);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [inmueblesUrl]);

  useEffect(() => {
    const svg = svgRef.current;
    if (!svg) return;

    // Limpiar el contenido del SVG
    svg.innerHTML = "";

    // Primero, dibujar los planos...
    // console.log(inmueblesData);
    //console.log(frame);
    //let time = isAnimationAttribute ? 1200 : 1;

    const createSVG = () => {
      inmueblesData[
        inmueblesData?.findIndex(
          (indexFrame: any) => indexFrame.frame === frame
        )
      ]?.properties?.forEach((apto, idx) => {
        if (apto.verts.length > 2) {
          let vertsOrder = ordenarVertices(apto.verts);
          const points = vertsOrder.map((coord) => coord.join(",")).join(" ");

          let currentApto = data?.property?.find(
            (value) => value.id === apto.id
          );
          let currentAttribute = data?.attributes?.find(
            (value) =>
              value.name === "Apto tipo" || value.name === "Locales y Oficinas"
          );

          if (!selectAvailability[currentApto?.availability]) {
            return;
          }

          if (
            !Object.values(isSelectedAttribute).some(
              (attr: any) =>
                Object.keys(attr).length > 0 && attr.attribute && attr.value
            )
          ) {
            // No hay atributos específicos seleccionados, continuar.
          } else if (
            !Object.values(isSelectedAttribute).every(
              (sel: any) =>
                sel.attribute && sel.value // Solo considerar atributos con valores no nulos o no indefinidos
                  ? currentApto?.values?.some(
                      (ap: any) =>
                        ap.attribute === sel.attribute && ap.value === sel.value
                    )
                  : true // Ignorar la validación de este atributo si no tiene valor significativo
            )
          ) {
            // Si no todos los atributos seleccionados cumplen con las condiciones, detener.
            return;
          }

          const handleTouchDown = (e: React.TouchEvent<SVGPolygonElement>) => {
            //setDragStart({ x: e.touches[0].clientX });
          };

          const handleMouseDown = (e: React.MouseEvent<SVGPolygonElement>) => {
            //setDragStart({ x: e.clientX });
          };

          const handleClick = () => {
            currentApto.verts = vertsOrder;
            setIsSelectedApto(currentApto);
          };

          const polygon = document.createElementNS(
            "http://www.w3.org/2000/svg",
            "polygon"
          );
          polygon.setAttribute("points", points);
          polygon.setAttribute("cursor", "pointer");
          polygon.setAttribute("data-type", "INMUEBLE");
          polygon.setAttribute("data-second", currentApto.property);
          polygon.setAttribute(
            "data-value",
            currentApto?.values?.find((e) =>
              e.hierarchicalLevel !== null
                ? e.hierarchicalLevel === "Jerarquico #1"
                : e.type === "Hierarchical"
            ).value
          );
          polygon.setAttribute(
            "pointer-events",
            dragStart ? "none" : "visiblefill"
          );
          polygon.addEventListener("click", handleClick);
          // polygon.addEventListener("mousedown", handleMouseDown);
          // polygon.addEventListener("touchstart", handleTouchDown);
          //console.log(data, data?.disponibilidad, currentApto?.availability);
          //console.log(currentAttribute)
          const fillColor = hexToRGBA(
            data?.disponibilidad && currentApto?.availability === "DISPONIBLE"
              ? "#00FA00"
              : data?.disponibilidad &&
                currentApto?.availability === "NO DISPONIBLE"
              ? "#000000"
              : data?.disponibilidad &&
                currentApto?.availability === "RESERVADO"
              ? "#EEA63A"
              : data?.disponibilidad && currentApto?.availability === "VENDIDO"
              ? "#FF0000"
              : currentAttribute !== undefined
              ? currentAttribute?.values?.find(
                  (x) =>
                    x.id ===
                    currentApto?.values?.find(
                      (e) => e.attribute === currentAttribute.id
                    )?.IdValue
                )?.layoutFill
              : "#000",
            0.45,
            currentApto
          );

          const strokeColor = hexToRGBA(
            data?.disponibilidad && currentApto?.availability === "DISPONIBLE"
              ? "#00FA00"
              : data?.disponibilidad &&
                currentApto?.availability === "NO DISPONIBLE"
              ? "#000000"
              : data?.disponibilidad &&
                currentApto?.availability === "RESERVADO"
              ? "#EEA63A"
              : data?.disponibilidad && currentApto?.availability === "VENDIDO"
              ? "#FF0000"
              : currentAttribute !== undefined
              ? currentAttribute?.values?.find(
                  (x) =>
                    x.id ===
                    currentApto?.values?.find(
                      (e) => e.attribute === currentAttribute.id
                    )?.IdValue
                )?.layoutFill
              : "#000000",
            0.8,
            currentApto
          );

          polygon.setAttribute("fill", fillColor); // Fondo semitransparente
          polygon.setAttribute("stroke", strokeColor); // Borde
          polygon.setAttribute("stroke-width", "2");

          // Añadir clase de animación si isSelectedApto coincide con el inmueble
          if (isSelectedApto?.id === currentApto?.id) {
            polygon.classList.add("titilar");
          }

          svg.appendChild(polygon);
          /* if (isAnimationAttribute) {
          setTimeout(() => {
            // Añadir el polígono al SVG
            svg.appendChild(polygon);
          }, 1200);
          setIsAnimationAttribute(false);
        } else { */
          // Añadir el polígono al SVG
          //    }
        } else {
          //let vertsOrder = ordenarVertices(apto.verts);
          const points = apto.verts;

          let currentApto = data?.property?.find(
            (value) => value.id === apto.id
          );
          let currentAttribute = data?.attributes?.find(
            (value) => value.name === "Apto tipo" || value.name === "Casas tipo"
          );

          if (!selectAvailability[currentApto?.availability]) {
            return;
          }

          if (
            !Object.values(isSelectedAttribute).some(
              (attr: any) =>
                Object.keys(attr).length > 0 && attr.attribute && attr.value
            )
          ) {
            // No hay atributos específicos seleccionados, continuar.
          } else if (
            !Object.values(isSelectedAttribute).every(
              (sel: any) =>
                sel.attribute && sel.value // Solo considerar atributos con valores no nulos o no indefinidos
                  ? currentApto?.values?.some(
                      (ap: any) =>
                        ap.attribute === sel.attribute && ap.value === sel.value
                    )
                  : true // Ignorar la validación de este atributo si no tiene valor significativo
            )
          ) {
            // Si no todos los atributos seleccionados cumplen con las condiciones, detener.
            return;
          }

          const handleTouchDown = (e: React.TouchEvent<SVGPolygonElement>) => {
            //setDragStart({ x: e.touches[0].clientX });
          };

          const handleMouseDown = (e: React.MouseEvent<SVGPolygonElement>) => {
            //setDragStart({ x: e.clientX });
          };

          const handleClick = () => {
            currentApto.verts = [points];
            setIsSelectedApto(currentApto);
          };

          // Crear y añadir el círculo al SVG
          const circle = document.createElementNS(
            "http://www.w3.org/2000/svg",
            "circle"
          );
          circle.setAttribute("cx", points[0].toString());
          circle.setAttribute("cy", points[1].toString());

          const fillColor = hexToRGBA(
            data?.disponibilidad && currentApto?.availability === "DISPONIBLE"
              ? "#00FA00"
              : data?.disponibilidad &&
                currentApto?.availability === "NO DISPONIBLE"
              ? "#000000"
              : data?.disponibilidad &&
                currentApto?.availability === "RESERVADO"
              ? "#EEA63A"
              : data?.disponibilidad && currentApto?.availability === "VENDIDO"
              ? "#FF0000"
              : currentAttribute !== undefined
              ? currentAttribute?.values?.find(
                  (x) =>
                    x.id ===
                    currentApto?.values?.find(
                      (e) => e.attribute === currentAttribute.id
                    )?.IdValue
                )?.layoutFill
              : "#000",
            0.45,
            currentApto
          );

          const strokeColor = hexToRGBA(
            data?.disponibilidad && currentApto?.availability === "DISPONIBLE"
              ? "#00FA00"
              : data?.disponibilidad &&
                currentApto?.availability === "NO DISPONIBLE"
              ? "#000000"
              : data?.disponibilidad &&
                currentApto?.availability === "RESERVADO"
              ? "#EEA63A"
              : data?.disponibilidad && currentApto?.availability === "VENDIDO"
              ? "#FF0000"
              : currentAttribute !== undefined
              ? currentAttribute?.values?.find(
                  (x) =>
                    x.id ===
                    currentApto?.values?.find(
                      (e) => e.attribute === currentAttribute.id
                    )?.IdValue
                )?.layoutFill
              : "#000000",
            0.8,
            currentApto
          );

          circle.setAttribute("r", (8 * 2).toString());
          circle.setAttribute("stroke", strokeColor);
          circle.setAttribute("fill", fillColor);
          circle.setAttribute("stroke-width", "2");
          //circle.setAttribute("class", `point-am`);

          circle.setAttribute("cursor", "pointer");
          circle.setAttribute("data-type", "INMUEBLE");
          circle.setAttribute("data-second", currentApto.property);
          circle.setAttribute(
            "data-value",
            currentApto?.values?.find((e) =>
              e.hierarchicalLevel !== null
                ? e.hierarchicalLevel === "Jerarquico #1"
                : e.type === "Hierarchical"
            ).value
          );
          circle.setAttribute(
            "pointer-events",
            dragStart ? "none" : "visiblefill"
          );
          circle.addEventListener("click", handleClick);

          // polygon.addEventListener("mousedown", handleMouseDown);
          // polygon.addEventListener("touchstart", handleTouchDown);

          // Añadir clase de animación si isSelectedApto coincide con el inmueble
          if (isSelectedApto?.id === currentApto?.id) {
            circle.classList.add("titilar");
          }

          // Crear el texto "Torre"
          const text = document.createElementNS(
            "http://www.w3.org/2000/svg",
            "text"
          );

          text.setAttribute("x", points[0].toString());
          text.setAttribute("y", `${points[1] + 4}`); // 40 píxeles por encima del círculo
          text.setAttribute("text-anchor", "middle"); // Centrar el texto horizontalmente
          text.setAttribute("fill", colors?.secondary_text); // Cambiar el color del texto a blanco
          text.setAttribute("cursor", "pointer"); // Agregar cursor: pointer al texto
          text.setAttribute("pointer-events", "visiblefill");
          text.setAttribute("font-size", ".75rem");
          text.textContent = currentApto.property;
          text.addEventListener("click", handleClick);
          if (isAnimationAttribute) {
            setTimeout(() => {
              // Añadir el polígono al SVG
              svg.appendChild(circle);
              svg.appendChild(text);
            }, 1200);
            setIsAnimationAttribute(false);
          } else {
            // Añadir el polígono al SVG
            svg.appendChild(circle);
            svg.appendChild(text);
          }
        }
      });
      setIsAnimationAttribute(false)
    };
    // Limpia el timeout anterior para evitar duplicaciones
    
    const timeoutId: any = isAnimationAttribute
      ? setTimeout(createSVG, 600)
      : createSVG();
    return () => {
      if (isAnimationAttribute) {
        clearTimeout(timeoutId); // Limpia el timeout si las dependencias cambian
      }
      //clearTimeout(timeoutGalery); // Limpia el timeout si las dependencias cambian
      svg.innerHTML = ""; // Limpia el SVG de inmediato cuando el efecto se limpia
    };
  }, [
    inmueblesData,
    screenWidth,
    screenHeight,
    frame,
    colors,
    filter,
    selectAvailability,
    isSelectedAttribute,
    isSelectedApto,
    dragStart,
    theme,
  ]);

  const ordenarVertices = (vertices) => {
    // Función para encontrar el ángulo polar de dos puntos
    const anguloPolar = (origen, punto) => {
      return Math.atan2(punto[1] - origen[1], punto[0] - origen[0]);
    };

    // Encontrar el vértice superior izquierdo (menor y, o en caso de empate, menor x)
    const superiorIzquierdo = vertices.reduce((prev, current) => {
      if (
        current[1] < prev[1] ||
        (current[1] === prev[1] && current[0] < prev[0])
      ) {
        return current;
      }
      return prev;
    });

    // Ordenar los vértices por ángulo polar, de menor a mayor
    const verticesOrdenados = vertices
      .filter((vertice) => vertice !== superiorIzquierdo) // Remover el vértice superior izquierdo
      .sort(
        (a, b) =>
          anguloPolar(superiorIzquierdo, a) - anguloPolar(superiorIzquierdo, b)
      );

    // Agregar el vértice superior izquierdo al inicio y al final para cerrar el polígono
    return [superiorIzquierdo, ...verticesOrdenados, superiorIzquierdo];
  };

  const hexToRGBA = (hex, alpha = 1, data) => {
    //console.log(data);
    //console.log(hex);
    
    // Elimina el # si está presente
    hex = hex.replace("#", "");

    // Convierte el valor hexadecimal a decimal
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // Normaliza los valores de color al rango de 0 a 255
    const alphaNormalized = Math.min(Math.max(alpha, 0), 1);
    const rNormalized = Math.min(Math.max(r, 0), 255);
    const gNormalized = Math.min(Math.max(g, 0), 255);
    const bNormalized = Math.min(Math.max(b, 0), 255);

    // Devuelve el valor RGBA en formato de cadena
    return `rgba(${rNormalized}, ${gNormalized}, ${bNormalized}, ${alphaNormalized})`;
  };

  // Función para estimar el tamaño del texto basado en la longitud del texto y el tamaño de la fuente
  const calcularTamanoDelTexto = (texto, fontSize) => {
    const canvas: any = document.createElement("canvas");
    const context: any = canvas.getContext("2d");
    context.font = `${fontSize}px sans-serif`; // Asume que usas una fuente sans-serif para el SVG
    const medida = context.measureText(texto);
    return { width: medida.width, height: fontSize }; // La altura es una estimación que podría ajustarse
  };

  return (
    <svg
      ref={svgRef}
      width={screenWidth}
      height={screenHeight}
      preserveAspectRatio="xMidYMid slice"
      viewBox={`0 0 ${originalWidth} ${originalHeight}`}
      style={{
        overflow: "hidden",
        pointerEvents: "none",
        position: "absolute",
        cursor: "pointer",
        top: 0,
      }}
    ></svg>
  );
}

export default PropertiesOverlaysContainer;
